import { GetTicketsByFiltersDtoProps } from "api/DTOs/GetTicketsByFiltersDto"
import { GetTicketsByFiltersDtoIPagedEnumerableProps } from "api/Schemas/GetTicketsByFiltersDtoIPagedEnumerable"

export default (data: GetTicketsByFiltersDtoIPagedEnumerableProps) =>
  data?.items?.map((ticket: GetTicketsByFiltersDtoProps) => ({
    conciliacionBancaria: ticket?.conciliacionBancaria,
    categoria: ticket?.categoria,
    fechaEmision: ticket?.fechaEmision,
    numero: ticket?.numero,
    estadoAprobacion: ticket?.estadoAprobacion,
    nombre: ticket?.nombre,
    contacto: ticket?.contacto,
    // TODO: endpoint. Propiedad pendiente de implementar (Solo está en el figma)
    // estadoPago: ticket?.estadoPago,
    importe: ticket?.importe,
    id: ticket?.id,
    haSidoModificado: ticket?.haSidoModificado,
  }))
